import { z } from 'zod/v4';

export const LinkActionsParamsSchema = z.object({
  id: z.string().min(1, 'Action ID is required'),
});
export type LinkActionsParams = z.infer<typeof LinkActionsParamsSchema>;

export const LinkActionsRequestSchema = z.object({
  actionIds: z
    .array(z.string().min(1, 'Action ID cannot be empty'))
    .min(1, 'At least one action ID is required'),
});
export type LinkActionsRequest = z.infer<typeof LinkActionsRequestSchema>;

export const LinkActionsResponseSchema = z.object({
  linkedCount: z.number(),
});
export type LinkActionsResponse = z.infer<typeof LinkActionsResponseSchema>;
